import React, { Component } from 'react'
import { t, Trans } from '@lingui/macro'
import Dropzone from 'react-dropzone'
import './CustomVideoInput.less'
import bytes from 'bytes'

import { ButtonPrimary } from 'front-end/src/components'
import IconCloudUpload from '../../../../../../../components/common/icon/IconCloudUpload'
import { notification } from '../../../../../../../components/common/notifications/Notifications'

const VIDEO_INPUT_ACCEPTED_MIMETYPES = [
  'audio/mp3',
  'audio/mpeg',
  'video/mp4',
  'video/avi',
  'video/mov',
  'video/webm',
  'video/quicktime',
  'video/x-ms-wmv',
  'video/x-msvideo',
  'video/mpeg',
  'video/3gpp',
  'video/3gpp2',
  'video/flv',
  'video/mkv',
  'video/ogv'
]

interface IProps {
  onSave: (file: File) => void
}

interface IState {
  loading: boolean
}
const fileBaseSize = 5
const maxFileSize = fileBaseSize * 1024 * 1024 * 1024 // 5GB

// TODO refactor to hooks
class CustomVideoInput extends Component<IProps, IState> {
  state: IState = {
    loading: false
  }

  handleDropAccepted = async (files: File[]) => {
    const file = files[0]
    const { onSave } = this.props
    onSave(file)
  }

  render() {
    return (
      <div className="CustomVideoInput">
        <Dropzone
          accept={VIDEO_INPUT_ACCEPTED_MIMETYPES.join(',')}
          onDropAccepted={this.handleDropAccepted}
          onDropRejected={(fileRejections) => {
            const [{ file }] = fileRejections
            console.log('rejected file: ', file)

            if (file.size > maxFileSize) {
              notification.error(
                t`Sorry, that file is ${bytes(
                  file.size
                )}, the upper limit for video file size is ${bytes(
                  maxFileSize
                )}`
              )
            } else {
              notification.error(t`Sorry, that file type is not supported`)
            }
          }}
          multiple={false}
          maxSize={maxFileSize}
        >
          {({ getRootProps, getInputProps, open }) => (
            <div
              className="Dropzone"
              style={{
                position: 'inherit',
                width: 'auto',
                height: 'auto'
              }}
              {...getRootProps()}
            >
              <IconCloudUpload />
              <input {...getInputProps()} />
              <ButtonPrimary
                onClick={(event) => {
                  event.stopPropagation()
                  open()
                }}
              >
                <Trans>Select video/audio file to upload</Trans>
              </ButtonPrimary>

              <p className="VideoElement__text">
                <Trans>or drag your video file here</Trans>
              </p>
              <p className="VideoElement__note">
                <Trans>
                  Looop accepts mp4, mp3, mov, avi, flv, wmv, ogv up to{' '}
                  {fileBaseSize}GB.
                </Trans>
              </p>
            </div>
          )}
        </Dropzone>
      </div>
    )
  }
}

export default CustomVideoInput
